import Home from 'screens/Home/teilverkauf'

export default Home
